import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { allCards } from '../use';

const { registerReducer } = useStorymapStore();

export class AllCardCommentsDeleted extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'AllCardCommentsDeleted';

    public constructor(public id: string) {
        super(AllCardCommentsDeleted.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: AllCardCommentsDeleted): void => {
    const card = allCards.value.find((x) => x.id === action.id);

    if (card) {
        card.hasComment = false;
    }
};

//@ts-ignore
registerReducer(AllCardCommentsDeleted.ACTION_TYPE, reducer);
